module.exports = __webpack_public_path__ + "img/Cuota_4x_RGB_verde.b7095d1d.svg";